import { render, staticRenderFns } from "./EditTask.vue?vue&type=template&id=1d5f0f3c&scoped=true"
import script from "./EditTask.vue?vue&type=script&lang=ts"
export * from "./EditTask.vue?vue&type=script&lang=ts"
import style0 from "./EditTask.vue?vue&type=style&index=0&id=1d5f0f3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f0f3c",
  null
  
)

export default component.exports